import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaType } from '../media-constant';
import { renderIELTSScoreConverter } from './renderElement';
import { IELTSCalculatorReadOnlyPlugin } from '../ielts-calculator/IELTSCalculatorReadOnlyPlugin';

export const IELTSScoreConverterPlugin = ({ isPreview }): SlatePlugin => {
  if (isPreview) {
    return IELTSCalculatorReadOnlyPlugin();
  }

  return {
    renderElement: renderIELTSScoreConverter,
    voidTypes: [MediaType.CONVERTER],
  };
};
